core.filter('prefix', [
    function() {
        return function(input, prefixString) {
            if (!_.isUndefined(input) && input != null) {
                return (prefixString + input);
            }
            else {
                return '-';
            }
        };
    }
]);